document.querySelectorAll("[data-img]").forEach(item => {
  item.addEventListener('click', function (e) {
    document.querySelectorAll("[data-img]").forEach(item => {
      item.classList.remove('active')
    })
    this.classList.add('active')
    document.querySelector('.product__galMain img').src = this.dataset.img
  })
})

document.querySelectorAll(".product__btnFav").forEach(item => {
  item.addEventListener('click', function (e) {
    e.stopPropagation()
    e.preventDefault()
    if (this.classList.contains("product__btnFav--active")) {
      this.classList.remove('product__btnFav--active')
    } else {
      this.classList.add('product__btnFav--active')
    }
  })
})
